import _ from 'lodash'
import uk from '@/assets/images/langs/uk.jpg'

export const getLanguages = () => {
  return [
    {
      code: 'en',
      title: 'English',
      flag: uk,
    },
  ]
}

export const getLang = (code: string) => {
  const options = getLanguages()
  return _.find(options, { code })
}
